import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() public id = '';

  @Output() private readonly tooltipClicked = new EventEmitter<string>();

  public onClicked() {
    this.tooltipClicked.emit(this.id);
  }
}
